export function isStudentDocumentBlob(blobName: string | null | undefined): boolean {
  return !!blobName?.trim().startsWith('students/');
}
